import { resolveOptionDisplayValue } from '../../platform/option-meta';

const STORAGE_CLASS_GENERIC_LABEL = '通用';

/**
 * 存储类展示：名称（displayName）> 提交值（storageClass）> 未配置。
 * useGenericWhenEmpty：无值时展示「通用」（计价空态等特殊场景）。
 */
export function resolveStorageClassDisplayLabel(
  storageClass: string | undefined,
  unconfiguredLabel: string,
  options?: { useGenericWhenEmpty?: boolean; displayName?: string },
): string {
  const name = options?.displayName?.trim();
  if (name) return name;
  const value = storageClass?.trim();
  if (value) return value;
  if (options?.useGenericWhenEmpty) return STORAGE_CLASS_GENERIC_LABEL;
  return unconfiguredLabel;
}

/** 从 optionMeta 解析磁盘列表的存储类展示名（name 优先，回退 value） */
export function buildStorageClassLabelMap(
  items: readonly ({ storageClass?: string } | object)[],
  optionMetaForm: Record<string, unknown>,
  fieldPathPrefix: string,
): Record<string, string> {
  const map: Record<string, string> = {};
  items.forEach((raw, index) => {
    const storageClass = (raw as { storageClass?: string }).storageClass;
    if (!storageClass) return;
    const label = resolveOptionDisplayValue(optionMetaForm, `${fieldPathPrefix}.${index}.storageClass`, storageClass);
    if (label) map[storageClass] = label;
  });
  return map;
}
